var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstructionsIcon = function SvgInstructionsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#InstructionsIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#423DCF",
    d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.374 12-12S18.626 0 12 0m2.498 18.598q-.926.364-1.479.556a3.9 3.9 0 0 1-1.282.192q-1.122 0-1.744-.547a1.77 1.77 0 0 1-.62-1.389q0-.328.045-.67a8 8 0 0 1 .15-.77l.773-2.731q.103-.394.173-.743.07-.35.07-.643 0-.521-.216-.728-.216-.205-.826-.204-.298 0-.615.091-.313.095-.537.179l.204-.841q.759-.31 1.453-.53a4.3 4.3 0 0 1 1.31-.221q1.114 0 1.72.538.602.538.603 1.398 0 .18-.042.627-.042.449-.154.824l-.77 2.722a8 8 0 0 0-.169.748 4 4 0 0 0-.074.636q0 .543.243.74.242.196.84.197.28 0 .636-.099.352-.098.514-.172zM14.36 7.547q-.537.5-1.295.5t-1.3-.5a1.6 1.6 0 0 1-.542-1.212q.002-.71.542-1.215a1.84 1.84 0 0 1 1.3-.505q.758 0 1.295.505.539.506.539 1.215 0 .712-.539 1.212"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "InstructionsIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgInstructionsIcon;